import { X } from "lucide-react";
import type { ReactNode } from "react";
import { Modal } from "../../components/Modal";
import { customerStatusLabel, partnerStatusLabel, statusTone } from "../../lib/loans";
import type { LoanStatus } from "../../types";

/** Long legal copy (authorisation, privacy notice) shown inside the flow, never on a separate site. */
export function LegalSheet({ open, title, body, onClose, action }: {
  open: boolean;
  title: string;
  body: string;
  onClose(): void;
  /** Optional primary action rendered under the text (e.g. "Aceptar y continuar"). */
  action?: ReactNode;
}) {
  const paragraphs = body.split(/\n\s*\n/).map((paragraph) => paragraph.trim()).filter(Boolean);
  return (
    <Modal open={open} label={title} onOpenChange={(next) => { if (!next) onClose(); }}>
      <div className="dialog-content wide loan-sheet">
        <button type="button" className="dialog-close" onClick={onClose} aria-label="Cerrar"><X size={18} aria-hidden="true" /></button>
        <span className="page-eyebrow">Peso a Peso Credipyme</span>
        <h2>{title}</h2>
        <div className="loan-sheet-body">
          {paragraphs.map((paragraph, index) => <p key={index}>{paragraph}</p>)}
        </div>
        {action && <div className="dialog-actions loan-sheet-actions">{action}</div>}
      </div>
    </Modal>
  );
}

export function LoanStatusTag({ status, audience = "customer" }: { status: LoanStatus; audience?: "customer" | "partner" }) {
  const label = audience === "partner" ? partnerStatusLabel(status) : customerStatusLabel(status);
  return <span className={`tag loan-status ${statusTone(status)}`}>{label}</span>;
}

/** The two-segment progress the design shows under the flow header. */
export function StepBar({ step }: { step: 1 | 2 }) {
  return (
    <div className="loan-steps" aria-hidden="true">
      <span className="on" />
      <span className={step === 2 ? "on" : ""} />
    </div>
  );
}
